import { render } from "./Loader.vue?vue&type=template&id=32681c9a&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=32681c9a&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32681c9a"]])

export default __exports__